function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  d: "M11.99 15.472c3.186 0 5.918 1.885 7.188 4.587a10.78 10.78 0 0 1-7.187 2.74c-2.76 0-5.272-1.035-7.178-2.73 1.257-2.708 3.987-4.597 7.178-4.597m0-8.613a3.698 3.698 0 0 1 3.715 3.706 3.698 3.698 0 0 1-3.715 3.706 3.699 3.699 0 0 1-3.706-3.706 3.699 3.699 0 0 1 3.706-3.706m0-5.658c5.973 0 10.808 4.826 10.808 10.799 0 2.757-1.035 5.263-2.73 7.168-1.126-2.132-3.055-3.775-5.395-4.494a4.91 4.91 0 0 0 2.233-4.11c0-2.706-2.21-4.906-4.916-4.906a4.916 4.916 0 0 0-4.907 4.907c0 1.719.892 3.232 2.233 4.11a9.148 9.148 0 0 0-5.395 4.493A10.75 10.75 0 0 1 1.2 12 10.78 10.78 0 0 1 11.99 1.201m0-1.201C5.368 0 0 5.378 0 12c.113 6.777 5.081 11.897 11.99 12 6.518-.028 11.945-5.008 12.01-12 0-6.622-5.387-12-12.01-12"
}));

const SvgIcProfile = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcProfile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-profile.ab2a7a9a.svg";
export { ForwardRef as ReactComponent };